/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagPl: {
  name: 'flag_pl';
  data: string;
} = {
  name: 'flag_pl',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#fff" d="M0 0h32v12H0V0Z"/><path fill="#DC143C" d="M0 12h32v12H0V12Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
